import {useSettings} from '@wix/tpa-settings/react'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import settingsParams from '../../../../../../settingsParams'
import {a11yTicketTypeId} from '../../a11y'
import {Labeled} from '../labeled'
import {classes} from './ticket-type.st.css'

const getTicketTypeHtmlTag = (subtitlesTag: string) => {
  if (['h6', 'p'].includes(subtitlesTag)) {
    return 'p'
  }

  const currentLevel = parseInt(subtitlesTag.charAt(1), 10)

  return currentLevel ? `h${currentLevel + 1}` : 'h3'
}

export const TicketType = ({
  ticket,
  className,
}: {
  ticket: wix.events.ticketing.TicketDefinition
  className?: string
}) => {
  const {t} = useTranslation()
  const settings = useSettings()
  const ticketId = a11yTicketTypeId(ticket)
  const subtitlesTag = settings.get(settingsParams.subtitlesTag) as string

  return (
    <Labeled label={t('viewer_ticketsPicker_ticketType')} labeledElementId={ticketId} className={className}>
      {({ariaLabeledBy}) => (
        <Text
          tagName={getTicketTypeHtmlTag(subtitlesTag)}
          id={ticketId}
          className={classes.name}
          data-hook={DH.NAME}
          aria-labelledby={ariaLabeledBy}
        >
          {ticket.name}
        </Text>
      )}
    </Labeled>
  )
}
